const config = {
    BASE_URL: "http://localhost",
    API_URL: process.env.REACT_APP_API_ENDPOINT,
    AUTH_BACKEND: 'Dummy'
}

export default config
